import PropTypes from 'prop-types'

import styles from './FormGroup.module.scss'

const HotelSetupFormGroup = ({
  children,
  title,
  description,
  disabled,
  contentPadding = '20px 25px'
}) => (
  <div className={styles.container}>
    <div className={styles.titleCol}>
      <p className={styles.title}>{title}</p>
      {description && <p className={styles.description}>{description}</p>}
    </div>
    <div
      className={disabled ? styles.contentDisabled : styles.content}
      style={{ padding: contentPadding }}
    >
      {children}
    </div>
  </div>
)

HotelSetupFormGroup.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  disabled: PropTypes.bool
}

export default HotelSetupFormGroup
